import React from 'react';
import PropTypes from 'prop-types';

import LinksNavigationBar
  from 'components/dashboard/links-content/links-layout/LinksNavigationBar';

import './LinksPageLayout.css';

const LinksPageLayout = ({ children, activeLinksPage }) => (
  <div className="links-page-layout__component">
    <LinksNavigationBar activeLinksPage={activeLinksPage} />
    {children}
  </div>
);

LinksPageLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  activeLinksPage: PropTypes.string.isRequired,
};

export default LinksPageLayout;
